import type { ECountryCode } from "@/domains/country/country.types";
import type { FormKitFrameworkContext } from "@formkit/core";
/**
 * @deprecated Do not add new Formkit usage
 */
import type { WritableComputedRef } from "vue";

import { useFormKitContext } from "@formkit/vue";
import { computed } from "vue";

export interface FormKitInputs {
  // Move into another file and split into multiple interfaces if it ever gets too big
  buildingMoreThan2Years: boolean;
  country: ECountryCode;
  addressType: string;
}

/**
 * A composable to return a reactive computed value for a given context.
 * @param context - The FormKit context to use.
 * @returns A `WritableComputedRef` for the value, or `undefined` if context is missing.
 */
function useFormkitComputedValue<T>(
  context: FormKitFrameworkContext<T> | undefined,
): WritableComputedRef<T | undefined> {
  return computed({
    get: () => context?._value,
    set: (value: T | undefined) => {
      if (context) {
        context.node.input(value);
      }
    },
  });
}

/**
 * A composable to access a typed FormKit value based on an ID.
 * @param id - The ID of the FormKit field.
 * @returns A `WritableComputedRef` representing the value, or `undefined` if no context is found.
 */
function useFormKitValue<K extends keyof FormKitInputs>(id: K): WritableComputedRef<FormKitInputs[K] | undefined> {
  const context = useFormKitContext(id);
  type Value = FormKitInputs[K];

  return computed<Value | undefined>({
    get: () => context?.value?._value as Value | undefined,
    set: (value: Value | undefined) => {
      if (context) {
        context.value?.node.input(value);
      }
    },
  });
}

export { useFormkitComputedValue, useFormKitValue };
